import React, { useEffect, useMemo } from 'react'
import { useMsal } from '@azure/msal-react'
import {  InteractionRequiredAuthError } from '@azure/msal-browser';
import { setAccessToken } from '../Redux/api';
import { getUserInfo } from '../Redux/actions/userActions';
import { useDispatch } from 'react-redux'
import { loginRequest } from '../msalConfiguration';

export default function Callback() {
  const { accounts, instance } = useMsal();
  const dispatch = useDispatch();


  const request = useMemo(() => {
    return {
      ...loginRequest,
      account: accounts.filter(a => a.username.includes(process.env.REACT_APP_AAD_DOMAIN) || a.username.includes("atech-bpo"))[0]
    }
  }, [accounts]);

  useEffect(() => {
    const getToken = async () => {
      await instance.acquireTokenSilent(request)
        .then(resp => {
          localStorage.setItem('accessInfo', JSON.stringify(resp));
          setAccessToken();
          dispatch(getUserInfo(() => { }));
          window.location = '/';
        })
        .catch(error => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(request).then(resp => {
              localStorage.setItem('accessInfo', JSON.stringify(resp));
              setAccessToken();
              dispatch(getUserInfo(() => { }));
            })
          }
        })
    }

    getToken();

  }, [dispatch, instance, request])


  return (
    <div>Validating...</div>
  )
}
